import { StateStorage } from 'zustand/middleware'
import { logger } from '@/lib/logger'

export const customStorage: StateStorage = {
  getItem: (name: string): string | null => {
    try {
      if (typeof window !== 'undefined') {
        return localStorage.getItem(name)
      }
      return null
    } catch (e) {
      return null
    }
  },
  setItem: (name: string, value: string) => {
    try {
      if (typeof window !== 'undefined') {
        localStorage.setItem(name, value)
      }
    } catch (e) {
      logger.error('Failed to set cache')
    }
  },
  removeItem: (name: string) => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(name)
    }
  }
}
